import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import compose from 'recompose/compose';

import FormControl from '../base/FormControl/FormControl';
import Select from '../base/Select/Select';

import LanguageIcon from '@material-ui/icons/Language';

import {
  languageOptions,
  hasSpecialCharacters,
  fonts,
  specialFonts
} from '../../constants/languageOptions';
import { setLanguage } from '../../actions/authentication';

const styles = theme => ({
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
  },
  languageIcon: {
    marginRight: theme.spacing(0.5),
    color: theme.palette.text.secondary,

    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(),
    },
  },
  selectLanguage: {
    marginTop: 0,
    width: 48,

    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(2),
    },
  },
  selectField: {
    padding: `0px ${theme.spacing(3)}px 0px 0px`,
    fontSize: 14,

    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
    },
  },
})

class SelectLanguage extends Component {
  user = this.props.user;
  initialLanguage = this.user && this.user.language

  state = {
    selectedLanguage: this.initialLanguage || '',
  }

  componentDidMount() {
    // reduce font-size and change font for Chinese, Japanese and Korean
    // this might not be needed after all
    if (hasSpecialCharacters(this.state.selectedLanguage)) {
      document.body.setAttribute('style', `font-size: 14px; font-family: ${specialFonts}`)
    }
  }

  componentDidUpdate() {
    if (this.props.user && !this.state.selectedLanguage) this.setState({selectedLanguage: this.props.user.language})
  }

  handleLanguageSelect = async e => {
    const selectedLanguage = e.target.value;
    const hasChanged = await this.props.actions.setLanguage(selectedLanguage);

    if (hasChanged) {
      this.setState({selectedLanguage});

      // reduce font-size and change font for Chinese, Japanese and Korean
      // this might not be needed after all
      if (hasSpecialCharacters(selectedLanguage)) {
        document.body.setAttribute('style', `font-size: 14px; font-family: ${specialFonts}`)
      } else {
        document.body.setAttribute('style', `font-size: 16px; font-family: ${fonts}`)
      }
    }
  }

  render() {
    const
      { classes } = this.props,
      { selectedLanguage } = this.state;

    return (
      <div className={classes.flexCenter}>
        <LanguageIcon className={classes.languageIcon}/>
        <div className={classes.selectLanguage}>
          <FormControl>
            <Select
              inputProps={{
                className: classes.selectField
              }}
              value={selectedLanguage}
              onChange={this.handleLanguageSelect}
              options={languageOptions}
              disableUnderline={true}
              hasNullOption={false}
            />
          </FormControl>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: {
    setLanguage: bindActionCreators(setLanguage, dispatch),
  }
})

export default compose(
  connect(null, mapDispatchToProps),
  withStyles(styles, {name: 'SelectLanguage'})
)(SelectLanguage)



// WEBPACK FOOTER //
// ./src/components/SelectLanguage/SelectLanguage.js